module.exports = __webpack_public_path__ + "static/media/Benu-Scroll-Demo.1ecf8417.m4v";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wizard/Benu-Scroll-Demo.m4v
// module id = 1501
// module chunks = 0